import {SET_MODULE_DATA, SET_SUBMODULE_DATA, SET_ISBH_DATA, SET_ISBH_REASON_DATA} from '.';
import {
  SetModuleDataPayloadParams,
  SetModuleAction,
  SetSubModuleDataPayloadParams,
  SetSubModuleAction,
  SetISBHAction,
  SetISBHReasonAction,
  IsBHPayload,
  IsBHReasonPayload
} from '../mappers/ModuleTypesMapper';

export const setModule = (
  dispatch: (action: SetModuleAction) => void,
  params: SetModuleDataPayloadParams
): void => {
  dispatch({
    type: SET_MODULE_DATA,
    payload: params
  });
};

export const setSubModule = (
  dispatch: (action: SetSubModuleAction) => void,
  params: SetSubModuleDataPayloadParams
): void => {
  dispatch({
    type: SET_SUBMODULE_DATA,
    payload: params
  });
};

export const setIsBH = (
  dispatch: (action: SetISBHAction) => void,
  params: IsBHPayload
): void => {
  dispatch({
    type: SET_ISBH_DATA,
    payload: params
  });
};

export const setIsBHReason = (
  dispatch: (action: SetISBHReasonAction) => void,
  params: IsBHReasonPayload
): void => {
  dispatch({
    type: SET_ISBH_REASON_DATA,
    payload: params
  });
};
